import React from "react"
import PowerfulActionsImage from "../../../../../components/staticQuery/platform/automation/PowerfulActionsImage"
import P from "../../../../../components/typography/P"
import GearGraphic from "../../../../../images/platform/automation/gear.svg"

const DescriptionText = () => (
  <>
    <P>
      In addition to sending Communication, you can add Actions to your
      Sequences. Update a Contact, deliver an SMS or Email Notification to your
      staff, transfer a Contact to another Sequence and more.
    </P>
    <P>
      Actions are incredibly powerful and can be triggered to automatically
      perform specific tasks, or a series of tasks as part of an Automation
      Sequence.
    </P>
  </>
)

const powerfulActionsData = {
  titleIcon: GearGraphic,
  title: "Powerful Actions",
  description: <DescriptionText />,
  graphic: <PowerfulActionsImage />,
  imageLeft: true,
  tint: "#F2F8F3",
  textLong: true,
  benefits: [],
}

export default powerfulActionsData
